// src/notifBus.js
// Extrait de GerantClientUI.jsx — Option B refactorisation (session v86)
// Contient : NOTIF_EVENTS, defaultNotifConfig, notifToastStore,
//            notifContextRef, setNotifContext, resolveRecipients, notifEventBus
//
// NOTE : useNotifToasts() reste dans GerantClientUI.jsx (dépend de React).
//        NotifToastStack reste aussi dans GerantClientUI.jsx (composant JSX).
//
// Importé par : TaskForm.jsx, Facturation.jsx (notifEventBus)
//              GerantClientUI.jsx (tout + setNotifContext, NOTIF_EVENTS, defaultNotifConfig)

import { supaAuthHeader } from './supabase.js';
import { SUPA_URL, SUPA_KEY } from './constants.js';
import { fname } from './utils.js';

export const NOTIF_EVENTS=[
  // ─── Pointages ───
  {section:'Pointages',id:'pointage_retard',label:'Retard pointage',desc:'Salarié non pointé après le délai configuré',delayBased:true,allowedRoles:['admin','gerant'],allowedChannels:['push','bandeau_inapp']},
  {section:'Pointages',id:'pointage_rappel',label:'Rappel pointage',desc:'Rappel au salarié avant que le retard ne soit déclaré',delayBased:true,allowedRoles:['assignee'],allowedChannels:['push']},
  {section:'Pointages',id:'journee_pas_demarree',label:'Journée non démarrée',desc:'Aucun pointage début posé après le délai',delayBased:true,allowedRoles:['admin','gerant'],allowedChannels:['push','bandeau_inapp']},
  {section:'Pointages',id:'journee_pas_cloturee',label:'Journée non clôturée',desc:'Pas de pointage fin après le délai en fin de journée',delayBased:true,allowedRoles:['admin','gerant'],allowedChannels:['push','bandeau_inapp']},
  {section:'Pointages',id:'assistance_demandee',label:'Demande d\'aide salarié',desc:'Un salarié en encadrement renforcé demande de l\'aide depuis le terrain',delayBased:false,allowedRoles:['admin','gerant'],allowedChannels:['push','bandeau_inapp']},
  {section:'Pointages',id:'cloture_attestee',label:'Clôture attestée',desc:'Un salarié en encadrement renforcé a clôturé sa journée (code de contrôle transmis)',delayBased:false,allowedRoles:['admin','gerant'],allowedChannels:['push','bandeau_inapp']},
  {section:'Pointages',id:'fin_journee_anomalie',label:'Fin de journée avec anomalie',desc:'Un salarié a terminé sa journée alors qu\'un rapport ou un pointage restait en suspens (lot 2)',delayBased:false,allowedRoles:['admin','gerant'],allowedChannels:['push','bandeau_inapp']},
  {section:'Pointages',id:'duree_signalee',label:'Seuil qualité signalé',desc:'Un salarié signale un empêchement à clôturer un ménage hors seuil de durée (trop tôt ou trop long)',delayBased:false,allowedRoles:['admin','gerant'],allowedChannels:['push','bandeau_inapp']},
  // ─── Tâches ───
  {section:'Tâches',id:'tache_affectee',label:'Tâche affectée',desc:'Une nouvelle tâche est affectée à un salarié ou prestataire',delayBased:false,allowedRoles:['assignee'],allowedChannels:['push','bandeau_inapp']},
  {section:'Tâches',id:'tache_modifiee',label:'Tâche modifiée',desc:'Modification d\'une tâche déjà affectée (horaire, bien, etc.)',delayBased:false,allowedRoles:['assignee'],allowedChannels:['push','bandeau_inapp']},
  {section:'Tâches',id:'tache_annulee',label:'Tâche annulée',desc:'Une tâche affectée est supprimée',delayBased:false,allowedRoles:['assignee'],allowedChannels:['push','bandeau_inapp']},
  {section:'Tâches',id:'menage_termine',label:'Ménage terminé',desc:'Un ménage est marqué comme terminé par le salarié',delayBased:false,allowedRoles:['admin','gerant'],allowedChannels:['push','bandeau_inapp']},
  // ─── Rapports & qualité ───
  {section:'Rapports & qualité',id:'rapport_soumis',label:'Rapport soumis',desc:'Un rapport de fin de ménage est soumis (à contrôler)',delayBased:false,allowedRoles:['admin','gerant'],allowedChannels:['push','bandeau_inapp']},
  {section:'Rapports & qualité',id:'anomalie_signalee',label:'Anomalie signalée',desc:'Une anomalie est signalée dans un rapport',delayBased:false,allowedRoles:['admin','gerant'],allowedChannels:['push','bandeau_inapp']},
  // ─── Messagerie ───
  {section:'Messagerie',id:'message_recu',label:'Message reçu',desc:'Notifie le destinataire du message (admin, direction, salarié, prestataire ou propriétaire). Option « Admin » : être prévenue de TOUS les messages qui circulent (supervision).',delayBased:false,allowedRoles:['assignee','admin'],allowedChannels:['push','bandeau_inapp','sms']},
];

// Valeurs par défaut "raisonnables" (cf. session 27/05 — Claire a accepté ce parti pris)
export function defaultNotifConfig(){
  return{
    pointage_retard:       {enabled:true, delayMin:15, recipients:['admin','gerant'], channels:['push','bandeau_inapp']},
    pointage_rappel:       {enabled:true, delayMin:10, recipients:['assignee'],       channels:['push']},
    journee_pas_demarree:  {enabled:true, delayMin:30, recipients:['admin','gerant'], channels:['push','bandeau_inapp']},
    journee_pas_cloturee:  {enabled:true, delayMin:60, recipients:['admin','gerant'], channels:['push','bandeau_inapp']},
    assistance_demandee:   {enabled:true, delayMin:0,  recipients:['admin','gerant'], channels:['push','bandeau_inapp']},
    cloture_attestee:      {enabled:true, delayMin:0,  recipients:['admin','gerant'], channels:['push','bandeau_inapp']},
    fin_journee_anomalie:  {enabled:true, delayMin:0,  recipients:['admin','gerant'], channels:['push','bandeau_inapp']},
    duree_signalee:        {enabled:true, delayMin:0,  recipients:['admin','gerant'], channels:['push','bandeau_inapp']},
    tache_affectee:        {enabled:true, delayMin:0,  recipients:['assignee'],       channels:['push']},
    tache_modifiee:        {enabled:true, delayMin:0,  recipients:['assignee'],       channels:['push']},
    tache_annulee:         {enabled:true, delayMin:0,  recipients:['assignee'],       channels:['push']},
    menage_termine:        {enabled:false,delayMin:0,  recipients:['admin'],          channels:['push']},
    rapport_soumis:        {enabled:true, delayMin:0,  recipients:['admin','gerant'], channels:['bandeau_inapp']},
    anomalie_signalee:     {enabled:true, delayMin:0,  recipients:['admin','gerant'], channels:['push','bandeau_inapp']},
    message_recu:          {enabled:true, delayMin:0,  recipients:['assignee'],       channels:['push']}, // sms volontairement OFF par défaut. Admin décoché par défaut : chacun n'est notifié que des messages QUI LUI sont adressés.
    sejour_importe:        {enabled:true, delayMin:0,  recipients:['admin','gerant'], channels:['bandeau_inapp']},
    sejour_a_verifier:     {enabled:true, delayMin:0,  recipients:['admin','gerant'], channels:['push','bandeau_inapp']},
  };
}


// ─── Store de toasts (mini observable pattern, sans dépendance externe) ───
// ─── Store de toasts (mini observable pattern, sans dépendance externe) ───
export const notifToastStore=(()=>{
  let toasts=[];
  const listeners=new Set();
  let counter=0;
  return{
    list:()=>toasts,
    subscribe(fn){listeners.add(fn);return()=>listeners.delete(fn);},
    push(toast){
      const id=++counter;
      const t={id,ts:Date.now(),...toast};
      toasts=[...toasts,t];
      listeners.forEach(fn=>fn(toasts));
      // auto-dismiss
      const ttl=toast.ttl||7000;
      setTimeout(()=>this.dismiss(id),ttl);
      return id;
    },
    dismiss(id){toasts=toasts.filter(t=>t.id!==id);listeners.forEach(fn=>fn(toasts));},
    clear(){toasts=[];listeners.forEach(fn=>fn(toasts));}
  };
})();


// ─── Dédoublonnage : on garde une fenêtre glissante des emits récents ───
// Si on émet plusieurs fois la même clé (event+destinataires) dans la fenêtre,
// on regroupe en augmentant un compteur et en mettant à jour le toast existant.
const NOTIF_DEDUP_WINDOW_MS=3500; // 3,5 sec : assez pour grouper un batch d'actions UI
const notifDedup=new Map(); // key → {count, lastTs, toastId}
function dedupKey(eventId,recipientIds){
  return `${eventId}::${[...(recipientIds||[])].sort().join(',')}`;
}

// ─── Bus principal ───
// Note importante : le bus a besoin de lire notifConfig à chaque emit. Comme on
// est en dehors d'un composant React, on s'appuie sur une "ref globale" mise à
// jour par un hook dans App. C'est moins joli qu'un contexte React mais c'est
// 10x plus simple et le pattern est testé (déjà utilisé dans voiceMode).
export const notifContextRef={current:{notifConfig:null, staff:[], gerants:[], prov:[], clients:[], sess:null}};
export function setNotifContext(ctx){notifContextRef.current={...notifContextRef.current,...ctx};}

// Résout un rôle abstrait ('admin', 'gerant', 'assignee', 'client') en IDs concrets.
// `payload` peut contenir un userId/userType pour résoudre `assignee`.
function resolveRecipients(role, payload, ctx){
  if(role==='admin')return [{type:'admin',id:'admin',name:'Admin'}];
  if(role==='gerant')return (ctx.gerants||[]).filter(g=>!g.archived&&!g.endDate).map(g=>({type:'gerant',id:g.id,name:g.name}));
  if(role==='client'){
    // Pour message_recu : si payload.toUserType='client', cibler ce proprio précis
    if(payload?.toUserType==='client'&&payload?.toUserId){
      const c=(ctx.clients||[]).find(x=>x.id===payload.toUserId);
      if(c)return [{type:'client',id:c.id,name:c.name}];
    }
    return [];
  }
  if(role==='assignee'){
    if(!payload?.toUserType||!payload?.toUserId)return [];
    if(payload.toUserType==='admin')return [{type:'admin',id:'admin',name:'Admin'}];
    const lists={staff:ctx.staff,gerant:ctx.gerants,provider:ctx.prov,client:ctx.clients};
    const arr=lists[payload.toUserType]||[];
    const u=arr.find(x=>x.id===payload.toUserId);
    if(!u)return [];
    return [{type:payload.toUserType,id:u.id,name:u.name||fname(u)||'?'}];
  }
  return [];
}

export const notifEventBus={
  emit(eventId, payload={}){
    const ctx=notifContextRef.current;
    const cfg=ctx.notifConfig?.[eventId];
    if(!cfg||!cfg.enabled){
      // event inconnu ou désactivé : silencieux mais loggé pour debug
      console.debug('[notifBus] skip (disabled)',eventId,payload);
      return;
    }
    // Résoudre tous les destinataires concrets
    const recipients=[];
    (cfg.recipients||[]).forEach(role=>{
      resolveRecipients(role,payload,ctx).forEach(r=>{
        if(!recipients.some(x=>x.type===r.type&&x.id===r.id))recipients.push(r);
      });
    });
    if(recipients.length===0){
      console.debug('[notifBus] no recipients resolved',eventId,payload);
      return;
    }
    // Dédoublonnage : si le même event a été émis pour les mêmes destinataires
    // dans la fenêtre, on incrémente le compteur du toast existant au lieu d'en
    // créer un nouveau.
    const key=dedupKey(eventId,recipients.map(r=>`${r.type}:${r.id}`));
    const nowTs=Date.now();
    const previous=notifDedup.get(key);
    const grouped=previous && (nowTs-previous.lastTs)<NOTIF_DEDUP_WINDOW_MS;
    const count=grouped?previous.count+1:1;

    // Dispatch par canal
    const channels=cfg.channels||[];
    const isAdmin=ctx.sess?.type==='admin';
    const recipientLabel=recipients.map(r=>r.name).join(', ');
    const title=NOTIF_EVENTS.find(e=>e.id===eventId)?.label||eventId;
    const body=payload.body||payload.summary||'';

    // ─── Bandeau in-app : l'utilisateur courant est-il destinataire de cet event ? ───
    // Si oui ET que le canal 'bandeau_inapp' est actif, on lui montre un vrai toast
    // (pas le toast de debug admin). Le mapping sess→destinataire : l'admin a
    // {type:'admin'}, les autres ont {type, id}.
    const inAppActive=channels.includes('bandeau_inapp');
    const sessType=ctx.sess?.type;
    const sessId=ctx.sess?.id||(sessType==='admin'?'admin':null);
    const currentIsRecipient=recipients.some(r=>r.type===sessType&&r.id===sessId);
    const showInAppToast=inAppActive&&currentIsRecipient&&!isAdmin;

    channels.forEach(ch=>{
      if(ch==='push'){
        // ─── Étape 5 : appel réel à l'Edge Function Supabase ───
        // Endpoint : https://<projet>.supabase.co/functions/v1/send-push-notification
        // Auth : token utilisateur courant (l'Edge Function vérifie l'authentification)
        const fnUrl=`${SUPA_URL}/functions/v1/send-push-notification`;
        const fnPayload={
          title,
          body:body||recipientLabel,
          tag:`${eventId}-${Date.now()}`,
          url:'/',
          recipients:recipients.map(r=>({type:r.type,id:r.id}))
        };
        // Fire-and-forget : on n'attend pas la réponse pour ne pas bloquer l'UI.
        // Les erreurs sont loggées en console (utile pour debug).
        fetch(fnUrl,{
          method:'POST',
          headers:{
            'apikey':SUPA_KEY,
            'Authorization':`Bearer ${supaAuthHeader()}`,
            'Content-Type':'application/json'
          },
          body:JSON.stringify(fnPayload)
        }).then(r=>r.ok?r.json():r.text().then(t=>Promise.reject(new Error(`HTTP ${r.status} ${t}`))))
          .then(res=>console.info('%c[notifBus push ✓]','color:#FF8617;font-weight:bold',eventId,res))
          .catch(err=>console.warn('[notifBus push ✗]',eventId,err.message));
      } else if(ch==='bandeau_inapp'){
        // Le toast in-app destinataire est géré plus bas (showInAppToast).
        // Ici on garde juste un log pour le debug console.
        console.info('%c[notifBus → in-app]','color:#4a9eff;font-weight:bold',eventId,{recipients,payload,shownToCurrentUser:showInAppToast,grouped:count>1?count:undefined});
      } else if(ch==='sms'){
        console.info('%c[notifBus → sms]','color:#86BD92;font-weight:bold',eventId,{recipients,payload,grouped:count>1?count:undefined});
      }
    });

    // Toast in-app : soit pour l'admin (mode debug, voit TOUT), soit pour un
    // destinataire non-admin quand le canal bandeau_inapp est actif et qu'il
    // fait partie des destinataires.
    if(isAdmin||showInAppToast){
      if(grouped && previous?.toastId){
        // Mettre à jour le toast existant : il faut le retirer et le republier
        // (le store n'a pas d'update, on garde le mécanisme simple).
        notifToastStore.dismiss(previous.toastId);
      }
      const toastId=notifToastStore.push({
        eventId,
        title,
        recipients:recipientLabel,
        channels:channels.filter(c=>c!=='sms'||eventId==='message_recu'), // sms montré seulement pour message_recu
        body:body.length>120?body.slice(0,117)+'…':body,
        count,
        debug:isAdmin, // true = toast technique admin ; false = vraie notif destinataire
      });
      notifDedup.set(key,{count,lastTs:nowTs,toastId});
    } else {
      notifDedup.set(key,{count,lastTs:nowTs,toastId:null});
    }

    // Nettoyage périodique du Map de dédup (anti-fuite)
    if(notifDedup.size>200){
      const cutoff=nowTs-NOTIF_DEDUP_WINDOW_MS*4;
      for(const[k,v]of notifDedup){if(v.lastTs<cutoff)notifDedup.delete(k);}
    }
  }
};
// Exposer pour debug console (utile pour Claire quand elle veut tester depuis devtools)
if(typeof window!=='undefined')window.notifEventBus=notifEventBus;


// Exposer pour debug console
if(typeof window!=='undefined')window.notifEventBus=notifEventBus;
